import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { FooterReport, Gap, GridInline, LabelTitle, Line, ProgressBar } from "../../../../components/Global";
import axios from "axios";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import PageFour from "./PageFour";
import LoadingPage from "./LoadingPage";

const PageThree = ({ idJadwalCbt, idKelas, idKelasParalel, kodeTahunAjaran, schoolName }) => {
    const [fetching, setFetching] = useState(false);
    const [dataSummaryMI, SetDataSummaryMI] = useState([]);
    const colors = ["#3f51b5", "#f44336", "#4caf50", "#ff9800", "#9c27b0", "#2196f3", "#009688", "#ffeb3b", "#795548", "#607d8b"];
    const [openPage, setOpenPage] = useState(false);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);

            const params = {
                idJadwalCbt: idJadwalCbt,
                idKelas: idKelas,
                idKelasParalel: idKelasParalel,
                kodeTahunAjaran: kodeTahunAjaran,
            };

            const response = await accountManagement.get(CONFIG_DEV.REPORT_PEMETAAN3_PAGE_THREE, { params }).catch(function (error) {
                console.error("Error Response Page Two", error);
            });

            if (response) {
                if (response.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page Three ", responseAPI);
                    console.log("====================================");

                    SetDataSummaryMI(responseAPI.dataSummaryMI);
                }
                setFetching(false);
                setOpenPage(true);
            }
        };
        getDatas();
    }, []);

    require("../Pemetaan.css");
    return (
        <div>
            <div className="report-page">
                <div className="header-second-page">
                    <GridInline width={"100%"}>
                        <GridInline width={"80%"}>
                            <LabelTitle label={"Placement Asesmen Diagnostik"} size={22} bolder={700} color={"#fff"} />
                            <LabelTitle label={schoolName} size={18} bolder={500} color={"#fff"} />
                        </GridInline>
                        <GridInline width={"20%"}>
                            <div
                                style={{
                                    border: "2px solid #fff",
                                    padding: 5,
                                    textAlign: "center",
                                    borderRadius: 10,
                                }}
                            >
                                <LabelTitle label={"SEKOLAH"} size={20} bolder={700} color={"#fff"} />
                            </div>
                        </GridInline>
                    </GridInline>
                </div>
                <Gap height={20} />
                <div className="section-three">
                    <div className="result">
                        <Gap height={20} />
                        <div className="rekap-table">
                            <table style={{ fontSize: 16, width: "100%" }}>
                                <thead style={{ backgroundColor: "#E9ECEF", fontSize: 17, textAlign: "center" }}>
                                    <tr>
                                        <th
                                            width="200"
                                            height="50"
                                            colSpan={2}
                                            style={{
                                                textAlign: "left",
                                                paddingLeft: 15,
                                            }}
                                        >
                                            HASIL MULTIPLE INTELLIGENCE
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dataSummaryMI.map((item, index) => {
                                        return (
                                            <tr>
                                                <td>
                                                    <Gap height={20} />
                                                    <GridInline width={"100%"}>
                                                        <GridInline width={"40%"}>
                                                            <LabelTitle label={item.kategori} size={16} bolder={700} color={"#000"} />
                                                        </GridInline>
                                                        <GridInline width={"30%"}>
                                                            <LabelTitle label={item.jumlahSiswa + " Siswa"} size={16} bolder={500} color={"#000"} />
                                                        </GridInline>
                                                    </GridInline>
                                                    <GridInline width={"100%"}>
                                                        <GridInline width={"95%"}>
                                                            <ProgressBar ratio={100} progressColor={colors[index]} progressValue={item.prosentaseSiswa} heightBar={15} />
                                                        </GridInline>
                                                        <GridInline width={"5%"} textAlign={"left"} verticalAlign={"bottom"} paddingLeft={10} paddingBottom={12}>
                                                            <LabelTitle label={item.prosentaseSiswa + "%"} size={16} bolder={500} color={"#000"} />
                                                        </GridInline>
                                                    </GridInline>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                                <tfoot></tfoot>
                            </table>
                        </div>
                    </div>
                </div>
                {/* <Gap height={40} /> */}
                {/* <div className="reportFooter">
                                <FooterReport color={"#1D3557"} date={dateTime} />
                            </div> */}
                {openPage ? <PageFour idJadwalCbt={idJadwalCbt} idKelas={idKelas} idKelasParalel={idKelasParalel} kodeTahunAjaran={kodeTahunAjaran} schoolName={schoolName} /> : <LoadingPage />}
            </div>
        </div>
    );
};

export default PageThree;
